import FolderIcon from '@mui/icons-material/Folder';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import {
  DocumentationViewItemType,
  isDirectoryItemType,
} from 'store/documentation/model/types';
import { ReactElement } from 'react';
import { Color } from 'shared/utils/colors';

export function DocumentationRowIcon({
  type,
  disabled,
  iconColorOverride,
  isEmptyDirectory,
}: {
  type: DocumentationViewItemType;
  disabled?: boolean;
  iconColorOverride?: string;
  isEmptyDirectory?: boolean;
}): ReactElement {
  const color =
    iconColorOverride ??
    (disabled ? Color.disabledGray : Color.iconGray);
  if (isDirectoryItemType(type)) {
    return isEmptyDirectory ? (
      <FolderOutlinedIcon htmlColor={color} />
    ) : (
      <FolderIcon htmlColor={color} />
    );
  }

  return <InsertDriveFileIcon htmlColor={color} />;
}
